import {useEffect} from 'react'

import {resetFavicon, updateFaviconByVariant, type Variants} from '@github-ui/favicon'
import type {CombinedState, StatusRollup} from '../page-data/payloads/status-checks'

const CombinedStateToFaviconVariant: Record<CombinedState, Variants> = {
  PASSED: 'success',
  PENDING: 'pending',
  PENDING_APPROVAL: 'pending',
  PENDING_FAILED: 'failure',
  PENDING_CONFLICTS: 'pending',
  SOME_FAILED: 'failure',
  FAILED: 'failure',
}

function useFaviconVariant(variant: Variants | undefined) {
  useEffect(() => {
    if (!variant) return

    if (variant === 'default') {
      resetFavicon()
    } else {
      updateFaviconByVariant(variant)
    }

    return () => {
      resetFavicon()
    }
  }, [variant])
}

export function useSyncFavicon(
  statusRollup: StatusRollup | undefined,
  {enabled = true, isInMergeQueue = false}: {enabled?: boolean; isInMergeQueue?: boolean} = {},
) {
  const variant =
    !enabled || !statusRollup
      ? undefined
      : isInMergeQueue
        ? 'merge-queue'
        : statusRollup.summary.length === 0
          ? 'default'
          : CombinedStateToFaviconVariant[statusRollup.combinedState]

  useFaviconVariant(variant)
}

export function useSyncMergeQueueFavicon({enabled = true}: {enabled?: boolean} = {}) {
  useFaviconVariant(enabled ? 'merge-queue' : undefined)
}
